var map = {
	"./boot": 407,
	"./boot.js": 407,
	"./core/application": 124,
	"./core/application.js": 124,
	"./core/auth/database": 430,
	"./core/auth/database.js": 430,
	"./core/auth/demo": 200,
	"./core/auth/demo.js": 200,
	"./core/auth/pam": 431,
	"./core/auth/pam.js": 431,
	"./core/auth/standalone": 432,
	"./core/auth/standalone.js": 432,
	"./core/authenticator": 119,
	"./core/authenticator.js": 119,
	"./core/config": 15,
	"./core/config.js": 15,
	"./core/connection": 53,
	"./core/connection.js": 53,
	"./core/connections/http": 201,
	"./core/connections/http.js": 201,
	"./core/connections/standalone": 433,
	"./core/connections/standalone.js": 433,
	"./core/connections/ws": 434,
	"./core/connections/ws.js": 434,
	"./core/dialog": 34,
	"./core/dialog.js": 34,
	"./core/init": 184,
	"./core/init.js": 184,
	"./core/locales": 10,
	"./core/locales.js": 10,
	"./core/mount-manager": 84,
	"./core/mount-manager.js": 84,
	"./core/package-manager": 61,
	"./core/package-manager.js": 61,
	"./core/process": 85,
	"./core/process.js": 85,
	"./core/search-engine": 417,
	"./core/search-engine.js": 417,
	"./core/service": 459,
	"./core/service.js": 459,
	"./core/settings-manager": 54,
	"./core/settings-manager.js": 54,
	"./core/storage": 118,
	"./core/storage.js": 118,
	"./core/storage/database": 435,
	"./core/storage/database.js": 435,
	"./core/storage/demo": 202,
	"./core/storage/demo.js": 202,
	"./core/storage/standalone": 436,
	"./core/storage/standalone.js": 436,
	"./core/storage/system": 437,
	"./core/storage/system.js": 437,
	"./core/theme": 60,
	"./core/theme.js": 60,
	"./core/window": 121,
	"./core/window-manager": 89,
	"./core/window-manager.js": 89,
	"./core/window.js": 121,
	"./dialogs.html": 517,
	"./dialogs/alert": 419,
	"./dialogs/alert.js": 419,
	"./dialogs/applicationchooser": 420,
	"./dialogs/applicationchooser.js": 420,
	"./dialogs/color": 421,
	"./dialogs/color.js": 421,
	"./dialogs/confirm": 422,
	"./dialogs/confirm.js": 422,
	"./dialogs/error": 423,
	"./dialogs/error.js": 423,
	"./dialogs/file": 425,
	"./dialogs/file.js": 425,
	"./dialogs/fileinfo": 424,
	"./dialogs/fileinfo.js": 424,
	"./dialogs/fileprogress": 426,
	"./dialogs/fileprogress.js": 426,
	"./dialogs/fileupload": 427,
	"./dialogs/fileupload.js": 427,
	"./dialogs/font": 428,
	"./dialogs/font.js": 428,
	"./dialogs/input": 429,
	"./dialogs/input.js": 429,
	"./gui/dataview": 126,
	"./gui/dataview.js": 126,
	"./gui/element": 40,
	"./gui/element.js": 40,
	"./gui/elements/containers": 438,
	"./gui/elements/containers.js": 438,
	"./gui/elements/fileview": 439,
	"./gui/elements/fileview.js": 439,
	"./gui/elements/iconview": 441,
	"./gui/elements/iconview.js": 441,
	"./gui/elements/inputs": 442,
	"./gui/elements/inputs.js": 442,
	"./gui/elements/listview": 443,
	"./gui/elements/listview.js": 443,
	"./gui/elements/menus": 444,
	"./gui/elements/menus.js": 444,
	"./gui/elements/misc": 445,
	"./gui/elements/misc.js": 445,
	"./gui/elements/richtext": 446,
	"./gui/elements/richtext.js": 446,
	"./gui/elements/tabs": 447,
	"./gui/elements/tabs.js": 447,
	"./gui/elements/treeview": 448,
	"./gui/elements/treeview.js": 448,
	"./gui/elements/visual": 449,
	"./gui/elements/visual.js": 449,
	"./gui/menu": 90,
	"./gui/menu.js": 90,
	"./gui/notification": 189,
	"./gui/notification.js": 189,
	"./gui/scheme": 190,
	"./gui/scheme.js": 190,
	"./gui/splash": 418,
	"./gui/splash.js": 418,
	"./helpers/date": 440,
	"./helpers/date.js": 440,
	"./helpers/default-application": 460,
	"./helpers/default-application-window": 461,
	"./helpers/default-application-window.js": 461,
	"./helpers/default-application.js": 460,
	"./helpers/event-handler": 122,
	"./helpers/event-handler.js": 122,
	"./helpers/google-api": 412,
	"./helpers/google-api.js": 412,
	"./helpers/hooks": 181,
	"./helpers/hooks.js": 181,
	"./helpers/iframe-application": 462,
	"./helpers/iframe-application-window": 450,
	"./helpers/iframe-application-window.js": 450,
	"./helpers/iframe-application.js": 462,
	"./helpers/loader": 187,
	"./helpers/loader.js": 187,
	"./helpers/service-notification-icon": 195,
	"./helpers/service-notification-icon.js": 195,
	"./helpers/settings-fragment": 410,
	"./helpers/settings-fragment.js": 410,
	"./helpers/window-behaviour": 411,
	"./helpers/window-behaviour.js": 411,
	"./helpers/windows-live-api": 416,
	"./helpers/windows-live-api.js": 416,
	"./locales/ar_DZ": 163,
	"./locales/ar_DZ.js": 163,
	"./locales/bg_BG": 164,
	"./locales/bg_BG.js": 164,
	"./locales/de_DE": 165,
	"./locales/de_DE.js": 165,
	"./locales/en_EN": 166,
	"./locales/en_EN.js": 166,
	"./locales/es_ES": 167,
	"./locales/es_ES.js": 167,
	"./locales/fa_FA": 168,
	"./locales/fa_FA.js": 168,
	"./locales/fr_FR": 169,
	"./locales/fr_FR.js": 169,
	"./locales/it_IT": 170,
	"./locales/it_IT.js": 170,
	"./locales/ko_KR": 171,
	"./locales/ko_KR.js": 171,
	"./locales/nl_NL": 172,
	"./locales/nl_NL.js": 172,
	"./locales/no_NO": 173,
	"./locales/no_NO.js": 173,
	"./locales/pl_PL": 174,
	"./locales/pl_PL.js": 174,
	"./locales/pt_BR": 175,
	"./locales/pt_BR.js": 175,
	"./locales/ru_RU": 176,
	"./locales/ru_RU.js": 176,
	"./locales/sk_SK": 177,
	"./locales/sk_SK.js": 177,
	"./locales/tr_TR": 178,
	"./locales/tr_TR.js": 178,
	"./locales/vi_VN": 179,
	"./locales/vi_VN.js": 179,
	"./locales/zh_CN": 180,
	"./locales/zh_CN.js": 180,
	"./login.html": 518,
	"./polyfill": 183,
	"./polyfill.js": 183,
	"./utils/clipboard": 203,
	"./utils/clipboard.js": 203,
	"./utils/colors": 199,
	"./utils/colors.js": 199,
	"./utils/compability": 123,
	"./utils/compability.js": 123,
	"./utils/cookies": 463,
	"./utils/cookies.js": 463,
	"./utils/dom": 31,
	"./utils/dom.js": 31,
	"./utils/events": 35,
	"./utils/events.js": 35,
	"./utils/fs": 39,
	"./utils/fs.js": 39,
	"./utils/gui": 55,
	"./utils/gui.js": 55,
	"./utils/keycodes": 88,
	"./utils/keycodes.js": 88,
	"./utils/misc": 52,
	"./utils/misc.js": 52,
	"./utils/preloader": 120,
	"./utils/preloader.js": 120,
	"./vfs/file": 30,
	"./vfs/file.js": 30,
	"./vfs/filedataurl": 188,
	"./vfs/filedataurl.js": 188,
	"./vfs/fs": 62,
	"./vfs/fs.js": 62,
	"./vfs/mountpoint": 408,
	"./vfs/mountpoint.js": 408,
	"./vfs/transport": 86,
	"./vfs/transport.js": 86,
	"./vfs/transports/applications": 191,
	"./vfs/transports/applications.js": 191,
	"./vfs/transports/dist": 192,
	"./vfs/transports/dist.js": 192,
	"./vfs/transports/dropbox": 193,
	"./vfs/transports/dropbox.js": 193,
	"./vfs/transports/google-drive": 194,
	"./vfs/transports/google-drive.js": 194,
	"./vfs/transports/onedrive": 196,
	"./vfs/transports/onedrive.js": 196,
	"./vfs/transports/osjs": 182,
	"./vfs/transports/osjs.js": 182,
	"./vfs/transports/web": 197,
	"./vfs/transports/web.js": 197,
	"./vfs/transports/webdav": 198,
	"./vfs/transports/webdav.js": 198
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 516;


//////////////////
// WEBPACK FOOTER
// ./javascript ^\.\/.*$
// module id = 516
// module chunks = 0